import { render, staticRenderFns } from "./EditMatchingDialog.vue?vue&type=template&id=129d7860"
import script from "./EditMatchingDialog.vue?vue&type=script&lang=js"
export * from "./EditMatchingDialog.vue?vue&type=script&lang=js"
import style0 from "./EditMatchingDialog.vue?vue&type=style&index=0&id=129d7860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports